import type { SavedFileTransfer } from "@rakazo/contracts";
import { SavedFileTransferSchema } from "@rakazo/contracts";

const FILE_TRANSFER_TYPE = "application/x-andrew-saved-file";

export function isSavedFileDrag(transfer: Pick<DataTransfer, "types">): boolean {
  return Array.from(transfer.types).includes(FILE_TRANSFER_TYPE);
}

export function writeSavedFileDrag(
  transfer: Pick<DataTransfer, "setData" | "effectAllowed">,
  file: SavedFileTransfer,
): void {
  transfer.effectAllowed = "copy";
  transfer.setData(FILE_TRANSFER_TYPE, JSON.stringify(SavedFileTransferSchema.parse(file)));
}

export function readSavedFileDrag(
  transfer: Pick<DataTransfer, "getData">,
): SavedFileTransfer | null {
  try {
    const value = transfer.getData(FILE_TRANSFER_TYPE);
    if (value.length > 2048) return null;
    const parsed = SavedFileTransferSchema.safeParse(JSON.parse(value));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
